import api, { handleResponse, handleError } from './api';

/**
 * Party calendar — guaranteed events, party starters, and live signals near you
 * in a date range (the calendar view of the feed, not a personal agenda).
 */
const calendarService = {
  async getCalendar({ lat, lng, radiusMi = 50, from, to } = {}) {
    try {
      return handleResponse(await api.get('/calendar', { params: { lat, lng, radiusMi, from, to } }));
    } catch (e) {
      return handleError(e);
    }
  },
};

export default calendarService;
